import { AxiosError } from "axios";

export class EndpointError {
  raw: any;
  message: string | null = null;
  code: number | null = null;

  constructor(err: AxiosError) {
    this.raw = err;

    this.code = err.response?.status ?? null;

    const resData = err.response?.data;

    if (resData) {
      if (resData.message) {
        this.message = resData.message;
      } else if (resData.errors) {
        if (typeof resData.errors === "string") {
          this.message = resData.errors;
        }
      }
    }
  }
}
